import { styled } from '@mui/material/styles'
import { colors, componentSizes } from '@theme/variables'

export const StyledHeader = styled('header')`
  padding: 16px 16px 16px 13px;
  min-height: ${componentSizes.headerMinHeight};
  flex-shrink: 0;
  position: relative;
  overflow: hidden;
  color: ${colors.black};
  display: flex;
  align-items: center;
`

export const UserProfileSectionWrapper = styled('div')`
  margin-left: auto;
`
